import { marketdataAPI } from "api/marketdata-api";
import {
  setErrorAC,
  setLoadingAC,
  setMarketBundleAC,
  setMarketdataProvidersAC,
  setTradingPlatformAC,
} from "./actions";
import { errorTypes } from "reducers/types";

const {
  marketdata: { GET_MARKETDATA_PROVIDERS_ERROR, GET_TRADING_PLATFORMS_ERROR },
} = errorTypes;

export const marketdataThunks = {
  getMarketDataProvidersTC: () => async (dispatch) => {
    try {
      dispatch(setLoadingAC(true));
      const response = await marketdataAPI.getMarketdataProviders();
      if (response.status === 200) {
        dispatch(
          setMarketdataProvidersAC(response.data.marketdataproviders || [])
        );
        dispatch(setMarketBundleAC(response.data.bundle || []));
      }
    } catch (error) {
      dispatch(
        setErrorAC({
          type: GET_MARKETDATA_PROVIDERS_ERROR,
          message: error.response.data?.message,
        })
      );
    } finally {
      dispatch(setLoadingAC(false));
    }
  },
  getTradingPlatformsTC: () => async (dispatch) => {
    try {
      dispatch(setLoadingAC(true));
      const response = await marketdataAPI.getTradingPlatforms();
      if (response.status === 200) {
        // Add hardcoded simulator trading platform
        const hardcodedSimulatorPlatform = {
          _id: "6683bce320eeff689a8f219a",
          price: 0,
          accountTypeRefs: ["simulator"],
          name: "Sterling Simulator",
          description: "Sterling Simulator",
          reference: "sterling_sim",
          software: "Sterling",
          softwareType: "Sim",
          traderIDprefix: "ZIMSTISIM",
          __v: 0,
          order: 999,
          active: true
        };

        // Combine API platforms with hardcoded simulator platform
        const allPlatforms = [
          ...(response.data.tradingplatforms || []),
          hardcodedSimulatorPlatform
        ];
        
        dispatch(setTradingPlatformAC(allPlatforms));
      }
    } catch (error) {
      dispatch(
        setErrorAC({
          type: GET_TRADING_PLATFORMS_ERROR,
          message: error.response.data?.message,
        })
      );
    } finally {
      dispatch(setLoadingAC(false));
    }
  },
};
